export default "__VITE_ASSET__CnS0bahJ__"